var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"themeselect-control"},[_c('text-control',{attrs:{"label":_vm.$t(_vm.label),"name":_vm.name},model:{value:(_vm.theme),callback:function ($$v) {_vm.theme=$$v},expression:"theme"}}),_c('button',{staticClass:"w3-input",on:{"click":_vm.changeTheme}},[_vm._v("Load")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }